import { Field, Flags, Select } from "components/shared/form";
import React from "react";

const ScenarioForm = (props) => {
    const { scenario, onChange, config, questionOptions } = props;
    const { name, description, startQuestionId, externalData, intFlags } = config;
    return (
        <>
            <Field {...name} onChange={onChange} value={scenario.name} />
            <Field {...description} onChange={onChange} value={scenario.description} />
            <Field
                {...externalData.config.propertyName}
                onChange={({ name, value }) =>
                    onChange({ name: "externalData", value: { ...scenario.externalData, [name]: value } })
                }
                value={scenario.externalData?.propertyName || ""}
            />
            <Select
                {...startQuestionId}
                onChange={onChange}
                value={scenario.startQuestionId}
                options={questionOptions}
            />
            <Flags {...intFlags} onChange={onChange} value={scenario.intFlags || 0} />
        </>
    );
};

export default ScenarioForm;
